var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Facebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24px",
    height: "24px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 8 3 C 5.25 3 3 5.25 3 8 L 3 16 C 3 18.75 5.25 21 8 21 L 16 21 C 18.75 21 21 18.75 21 16 L 21 8 C 21 5.25 18.75 3 16 3 L 8 3 z M 8 4.5 L 16 4.5 C 17.93 4.5 19.5 6.07 19.5 8 L 19.5 16 C 19.5 17.93 17.93 19.5 16 19.5 L 12.511719 19.5 L 12.511719 13.501953 L 15.251953 13.501953 A 0.750075 0.750075 0 1 0 15.251953 12.001953 L 12.511719 12.001953 L 12.511719 10.755859 C 12.511719 10.055837 13.061696 9.5058594 13.761719 9.5058594 L 15.251953 9.5058594 A 0.750075 0.750075 0 1 0 15.251953 8.0058594 L 13.761719 8.0058594 C 12.251741 8.0058594 11.011719 9.2458824 11.011719 10.755859 L 11.011719 12.001953 L 9.7519531 12.001953 A 0.750075 0.750075 0 1 0 9.7519531 13.501953 L 11.011719 13.501953 L 11.011719 19.5 L 8 19.5 C 6.07 19.5 4.5 17.93 4.5 16 L 4.5 8 C 4.5 6.07 6.07 4.5 8 4.5 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Facebook);
export default __webpack_public_path__ + "static/media/icons8-facebook.a371ccdb6ac9dccb4d873c349451087e.svg";
export { ForwardRef as ReactComponent };